import React, { FC } from 'react';
import { ModalManager, ModalRouteProps } from 'context/ModalRouter';
import DuplicatePostsPreselectedPosts from 'app/modules/posts/modules/duplicatePosts/components/DuplicatePostsPreselectedPosts';
import DuplicatePostsPostsSelection from 'app/modules/posts/modules/duplicatePosts/components/DuplicatePostsPostsSelection';
import Modal from 'components/shared/Modal';
import { PageData, PagesProjects } from 'types/Page';
import { UserStore } from 'modules/user/userReducer';
import { ListPost } from 'types/PostDetail';
import { ActivityIndicator } from '@kontentino/ui';

type Props = {
  modalManager: ModalManager;
  pages: PageData[];
  user: UserStore;
  initialPosts: ListPost[];
  isLoading?: boolean;
  initialProjects?: PagesProjects;
  postsProjects?: PagesProjects;
} & ModalRouteProps;

const DuplicatePostsModal: FC<Props> = ({
  pages,
  user,
  initialPosts,
  isLoading,
  modalManager,
  initialProjects,
  postsProjects,
  ...props
}) => {
  return (
    <Modal
      size="md"
      modalManager={modalManager}
      isLoading={isLoading}
      onClose={() => modalManager.close()}
      dataCy={{
        closeButton: 'duplicate-posts-modal-close-button',
      }}
      {...props}
    >
      {isLoading && (
        <div className="tw-flex tw-h-full  tw-w-full tw-justify-center tw-p-4">
          <ActivityIndicator className="tw-h-24  tw-w-24 tw-shrink-0" />
        </div>
      )}

      {!isLoading && (
        <>
          {initialPosts?.length ? (
            <DuplicatePostsPreselectedPosts
              initialProjects={initialProjects}
              postsProjects={postsProjects}
              pages={pages}
              initialPosts={initialPosts}
              onFinish={() => modalManager.close()}
            />
          ) : (
            <DuplicatePostsPostsSelection
              initialProjects={initialProjects}
              postsProjects={postsProjects}
              pages={pages}
              onFinish={() => modalManager.close()}
              user={user}
            />
          )}
        </>
      )}
    </Modal>
  );
};

export default DuplicatePostsModal;
